import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QuickCommentInterface } from '../../../models/quickComment-inteface';
import { Question } from '../../../models/question-interface';
import { DownloadCheck } from '../../../models/download-interface';
import { DownloadModalService } from '../../../services/download-modal.service';
import { take } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import {
  Document, Packer, Paragraph, Table, TableCell, TableRow, WidthType, TextRun, PageNumber,
  PageOrientation, BorderStyle, NumberFormat, Footer, AlignmentType, ImageRun, dateTimeValue, PageBreak, UnderlineType
} from "docx";
import { Buffer } from 'buffer';
import { CheckStorageService } from '../../../services/check-storage.service';
import { TranslateService } from "@ngx-translate/core";
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { QuestionnairesService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/services/questionnaires.service';
import { UserQuestion } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';

@Component({
  selector: 'lib-download-modal',
  templateUrl: './download-modal.component.html',
  styleUrls: ['./download-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DownloadModalComponent {

  public id: any;
  public check: any = {};
  public institution: any = {};
  public wardsAndDepartments: any = {};
  public departments: any = {};
  public gDate: string = '';
  public timeCreated: string = new Date().toLocaleTimeString(localStorage.getItem('selectedlanguage') ? localStorage.getItem('selectedlanguage') : 'en', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit', year: 'numeric' });
  public userNamer = '';
  public institutionName: string = '';
  public wardName: string = '';
  public departmentName: string = '';
  public creationDate: string = '';
  public creationHour: string = '';
  public questionTypeIds = {
    yesNo: "2A7D7C31-524C-4625-B6E9-895B110E0F5D",
    star: "AC6235D3-1399-45CE-B6F5-9E997D1F467C",
    score: "3E8A3A99-CA82-4D8A-B733-06BF851D239F",
    numerical: "9719534F-3855-43EA-B6F4-0D13FEB02D28"
  }

  constructor(
    private checkStorageService: CheckStorageService,
    private downloadModalService: DownloadModalService,
    private translateService: TranslateService,
    private questionnaireService: QuestionnairesService,
    public layoutService: PHBHPLayoutPackageService
  ) {
    this.downloadModalService.downloadModal$.subscribe((resp: any) => {
      this.id = resp.id;
      this.institutionName = resp.institutionName;
      this.wardName = resp.wardName;
      this.departmentName = resp.departmentName;
      this.creationDate = resp.creationDate;
      this.creationHour = resp.creationHour;
      this.userNamer = resp.username;
    });
  }

  download(): void {
    if (this.id) {
      this.layoutService.showLoader = true;
      this.checkStorageService.getChecksById(this.id).subscribe((check: any) => {
        this.check = check;
        this.gDate = this.formatDate(check.creationDate);
        this.checkStorageService.getInstitutionDetails(check.institutionId).subscribe((institution: any) => {
          this.institution = institution.institution.institution;
          this.checkStorageService.getWardsAndDepartments(check.institutionId).subscribe((wardsAndDepartments: any) => {
            this.wardsAndDepartments = wardsAndDepartments.wardsDetails.filter((wardAndDepartment: any) => wardAndDepartment.wardID === check.wardId)[0];
            this.departments = wardsAndDepartments.departments.filter((department: any) => department.departmentID === this.wardsAndDepartments.departmentID)[0];
            this.createDocument();
          }, (error) => { this.layoutService.showLoader = false; });
        }, (error) => { this.layoutService.showLoader = false; });
      }), (error) => { this.layoutService.showLoader = false; };
    }
  }

  translateText(text: string) {
    let result: string = text;
    this.translateService.get(text).subscribe((res: string) => {
      result = res;
    });
    return result;
  }

  createDocument(): void {
    var comment = this.check.userQuestionnaire.comment;
    if (!comment) comment = "";

    if (comment === "") {
      comment = `[${this.layoutService.translateText('CHECK.NOTES_MESSAGE')}]`;
    }

    const removeBorders = {
      style: BorderStyle.NONE,
      color: "#FFFFFF",
    }

    const noneBorders = {
      top: removeBorders,
      bottom: removeBorders,
      left: removeBorders,
      right: removeBorders,
    }

    const reportComments = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(
                {
                  children: [new TextRun({
                    text: comment,
                    color: "#0643FD",
                    vanish: false
                  }),]
                }
              ), new Paragraph(""), new Paragraph(""), new Paragraph("")],
              borders: noneBorders,
              shading: { fill: "#e8edfc" },
            }),
          ]
        })
      ],
      borders: noneBorders,
      width: {
        size: "100%",
        type: WidthType.PERCENTAGE
      }
    });

    const reportComent1 = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(
                {
                  children: [new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.WRITE_SUMMARY_HERE'),
                    color: "#0643FD",
                    vanish: false
                  }),]
                }
              ), new Paragraph(""), new Paragraph(""), new Paragraph("")],
              borders: noneBorders,
              shading: { fill: "#e8edfc" },
            }),
          ]
        })
      ],
      borders: noneBorders,
      width: {
        size: "100%",
        type: WidthType.PERCENTAGE
      }
    })

    const reportComent2 = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(
                {
                  children: [new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.WRITE_SOURCES_HERE'),
                    color: "#0643FD",
                    vanish: false
                  }),]
                }
              ), new Paragraph(""), new Paragraph(""), new Paragraph("")],
              borders: noneBorders,
              shading: { fill: "#e8edfc" },
            }),
          ]
        })
      ],
      borders: noneBorders,
      width: {
        size: "100%",
        type: WidthType.PERCENTAGE
      }
    })

    const reportComent3 = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(
                {
                  children: [new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.WRITE_ATTACHMENTS_HERE'),
                    color: "#0643FD",
                    vanish: false
                  }),]
                }
              ), new Paragraph(""), new Paragraph(""), new Paragraph("")],
              borders: noneBorders,
              shading: { fill: "#e8edfc" },
            }),
          ]
        })
      ],
      borders: noneBorders,
      width: {
        size: "100%",
        type: WidthType.PERCENTAGE
      }
    })

    const header = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.AUDIT_REPORT'),
                    size: 32,
                    font: "Calibri"
                  })
                ]
              })],
              width: { size: 50, type: WidthType.PERCENTAGE },
              shading: { fill: "#1F3863" }
            }),
            new TableCell({
              children: [new Paragraph("")],
              width: { size: 50, type: WidthType.PERCENTAGE },
              shading: { fill: "#1F3863" }
            })
          ],
        })
      ],
      width: { size: 100, type: WidthType.PERCENTAGE }
    });

    const userData = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.REPORT.EQUIPMENT')}:`,
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.institution.institutionName,

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.REPORT.ADDRESS')}:`,
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders,
              margins: { bottom: 0, left: 0, right: 0, top: 0 }
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.institution.addressLine1 + " " + this.institution.addressLine2 + " " + this.institution.city,

                  })
                ]
              })],
              width: { size: "40%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.REPORT.DEPARTMENT')}:`,
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.translateText(this.departments.departmentName),
                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.REPORT.DATE')}:`,
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders,
              margins: { bottom: 0, left: 0, right: 0, top: 0 }
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.gDate,
                  })
                ]
              })],
              width: { size: "40%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.CHECK_OWNER')}:`,
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.userNamer,
                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.REPORT.ADDITIONAL_PARTICIPANT_SHORT')}:`,
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders,
              margins: { bottom: 0, left: 0, right: 0, top: 0 }
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: "",

                  })
                ]
              })],
              width: { size: "40%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: "",
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: "",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.REPORT.PARTICIPANT')}:`,
                    bold: true,
                    color: "#1F3863",

                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders,
              margins: { bottom: 0, left: 0, right: 0, top: 0 }
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.check.furtherParticipant,

                  })
                ]
              })],
              width: { size: "40%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: `${this.layoutService.translateText('CHECK.REPORT.DISTRIBUTOR')}:`,
                    bold: true,
                    color: "#1F3863",
                  })
                ]
              })],
              width: { size: "20%", type: WidthType.PERCENTAGE },
              borders: noneBorders
            }),
            new TableCell({
              children: [new Paragraph({
                children: [
                  new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.WRITE_MAIL_LIST'),
                    color: "#0643FD",
                    vanish: false
                  })
                ]
              })],
              borders: noneBorders,
              shading: { fill: "#e8edfc" },
              columnSpan: 3
            }),
          ]
        })
      ],
      borders: noneBorders,
      width: {
        size: "100%",
        type: WidthType.PERCENTAGE
      }
    });

    var questionArray: TableRow[] = [];
    const headerStyle = {
      shading: {
        fill: "#1F3863", // Set the background color to #1F3863
      },
    };

    const blueSpace = {
      shading: {
        fill: "#c7d9ff", // Set the background color to #1F3863
      },
    };

    this.check.userQuestionnaire.userQuestions.forEach((question: UserQuestion) => {

      if (question.userAnswerSelectedId != null && question.userAnswers && question.userAnswers.length > 0) {
        const userAnswer = question.userAnswers.find((answer: any) => answer.id === question.userAnswerSelectedId);
        
        //Clean the comment
        var comment = question.comment;
        if (comment != null) {
          while (comment.includes("<br>")) {
            comment = comment.replace("<br>", "\n");
          }
        }
        question.comment = comment;

        if (userAnswer != null
          && (((this.isAnswerYes(userAnswer.statement) || this.isAnswerNA(userAnswer.statement)) && question.comment !== null) || (!this.isAnswerYes(userAnswer.statement) && !this.isAnswerNA(userAnswer.statement)))) {
          let questionHeader = new TableRow({
            children: [
              new TableCell({
                width: { size: "25%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.THEME'),
                    bold: true
                  })
                  ]
                })], ...headerStyle
              }),
              new TableCell({
                width: { size: "50%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.VALORATION'),
                    bold: true
                  })
                  ]
                })], ...headerStyle
              }),
              new TableCell({
                width: { size: "25%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [new TextRun({
                    text: this.layoutService.translateText('CHECK.REPORT.COMMENT'),
                    bold: true
                  })
                  ]
                })], ...headerStyle
              }),
            ],
          });

          console.error('Question statement', question.statement);
          let statementTag = this.extractTextFromTags(question.statement);
          console.error('StatementTab', statementTag);
          statementTag = statementTag.trim();
          statementTag = statementTag.replace('?', '');
          statementTag = this.changeTextByTitle(statementTag);

          var defaultData = '';
          if (this.isAnswerNo(userAnswer.statement) || this.isAnswerPartially(userAnswer.statement)) {
            defaultData = question.defaultData;
            defaultData = defaultData.trim();
          }

          var questionComment = '';
          if (question.comment != null) {
            questionComment = question.comment;
            questionComment = comment.trim();
          }

          if (this.isAnswerYes(userAnswer.statement) && questionComment != '') {
            defaultData = this.layoutService.translateText('CHECK.REPORT.OK_HYGIENIC_VIEW');
          }

          if (this.isAnswerNA(userAnswer.statement) && questionComment != '') {
            defaultData = this.layoutService.translateText('CHECK.REPORT.NOT_RELEVANT');
          }

          let questionRow = new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: statementTag,
                      bold: true,
                      color: "#1F3863",
                      underline: {
                        type: UnderlineType.SINGLE,
                        color: "#1F3863",
                      },
                    })
                  ]
                })], width: { size: "25%", type: WidthType.PERCENTAGE }
              }),
              new TableCell({ children: [new Paragraph(defaultData != null ? defaultData : '')], width: { size: "50%", type: WidthType.PERCENTAGE } }),
              new TableCell({ children: [new Paragraph(questionComment != '' ? question.comment : '')], width: { size: "25%", type: WidthType.PERCENTAGE } }),
            ],
          });

          if ((defaultData != null && defaultData !== '') || (question.comment != null && question.comment !== '')) {
            questionArray.push(questionHeader);
            questionArray.push(questionRow);
          }
        }
      } else {
        
        if (question.isCaption) return;

        // If no answer was selected, don't include this question in the report.
        if (!question.userAnswersSelected || question.userAnswersSelected.length === 0) {
          return;
        }

        //Dont include the answer if the question Star/Score are perfect and they don't have comments.
        let booleanIncludeAnswer = true;
        switch (question.questionTypeId.toLowerCase()) {              
          case this.questionTypeIds.star.toLowerCase():                
            let starRating = parseInt(question.userAnswersSelected[0].caption);
            if (starRating == 5 && (question.comment == null || question.comment === '')) booleanIncludeAnswer = false;
            break;
          
          case this.questionTypeIds.score.toLowerCase():            
            let score = parseInt(question.userAnswersSelected[0].caption);
            if (score == 10 && (question.comment == null || question.comment === '')) booleanIncludeAnswer = false;            
            break;          
        }

        if (!booleanIncludeAnswer) return;
        
        var comment = question.comment;
        if (comment != null) {
          while (comment.includes("<br>")) {
            comment = comment.replace("<br>", "\n");
          }
        }

        question.comment = comment;
        let questionHeader = new TableRow({
          children: [
            new TableCell({
              width: { size: "25%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({
                  text: this.layoutService.translateText('CHECK.REPORT.THEME'),
                  bold: true
                })
                ]
              })], ...headerStyle
            }),
            new TableCell({
              width: { size: "50%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({
                  text: this.layoutService.translateText('CHECK.REPORT.VALORATION'),
                  bold: true
                })
                ]
              })], ...headerStyle
            }),
            new TableCell({
              width: { size: "25%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({
                  text: this.layoutService.translateText('CHECK.REPORT.COMMENT'),
                  bold: true
                })
                ]
              })], ...headerStyle
            }),
          ],
        });

        if (question.userAnswersSelected && question.userAnswersSelected.length > 0) {

          let statementTag = question.themeSection ? question.themeSection : this.extractTextFromTags(question.statement);
          let questionText = [];

          if (question.skin == 'Radio' && question.userAnswersSelected.length == 1 && this.isYesNoQuestion(question.userAnswersSelected[0].caption)) {
            if ((question.comment !== null && question.comment !== '')
              || (this.isAnswerNo(question.userAnswersSelected[0].caption) || this.isAnswerPartially(question.userAnswersSelected[0].caption))
            ) {
              questionText.push(new Paragraph(question.assessmentParagraph ? question.assessmentParagraph : this.transformStatementToQuestion(question.statement)));
            }// else nothing to show
          } else {
            if (question.assessmentParagraph && question.assessmentParagraph !== '') {
              let defaultData = question.assessmentParagraph ? question.assessmentParagraph : this.transformStatementToQuestion(question.statement);
              questionText.push(new Paragraph(defaultData));
              questionText.push(new Paragraph(''));
            } else {
              let questionTitle = this.transformStatementToQuestion(question.statement);
              questionText.push(new Paragraph(questionTitle));
              questionText.push(new Paragraph(''));
            }

            let answer = '';
            switch (question.questionTypeId.toLowerCase()) {
              case this.questionTypeIds.star.toLowerCase():
                let starRating = parseInt(question.userAnswersSelected[0].caption);
                for (let i = 0; i < starRating; i++) {
                  answer += '✮';
                }
                for (let i = starRating; i < question.max; i++) {
                  answer += '✰';
                }

                break;
              case this.questionTypeIds.score.toLowerCase():
                const lines = (question.referenceDesc ?? '').split('\n');
                lines.forEach(line => {
                  questionText.push(new Paragraph(line));
                });

                questionText.push(new Paragraph(''));
                answer += this.layoutService.translateText('CHECK.QUESTIONS.VALUE') + ': ';
                question.userAnswersSelected.forEach(answerSelected => {
                  answer += this.layoutService.translateText(answerSelected.caption) + ', ';
                });

                break;
              case this.questionTypeIds.numerical.toLowerCase():
                answer += this.layoutService.translateText('CHECK.QUESTIONS.VALUE') + ': ';
                question.userAnswersSelected.forEach(answerSelected => {
                  answer += this.layoutService.translateText(answerSelected.caption) + ', ';
                });

                break;
            }

            if (answer.endsWith(', ')) {
              answer = answer.slice(0, -2);
            }

            questionText.push(new Paragraph(answer));
            questionText.push(new Paragraph(''));
          }

          var questionComment = '';
          if (question.comment != null) {
            questionComment = question.comment;
            questionComment = comment.trim();
          }

          let questionRow = new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: statementTag,
                      bold: true,
                      color: "#1F3863",
                      underline: {
                        type: UnderlineType.SINGLE,
                        color: "#1F3863",
                      },
                    })
                  ]
                })], width: { size: "25%", type: WidthType.PERCENTAGE }
              }),
              new TableCell({ children: questionText, width: { size: "50%", type: WidthType.PERCENTAGE } }),
              new TableCell({ children: [new Paragraph(questionComment != '' ? question.comment : '')], width: { size: "25%", type: WidthType.PERCENTAGE } }),
            ],
          });

          if(questionText.length > 0 || (question.comment != null && question.comment !== '')) {
            questionArray.push(questionHeader);
            questionArray.push(questionRow);
          }

        } else {
          let statementTag = question.themeSection ? question.themeSection : this.extractTextFromTags(question.statement);
          let defaultData = question.assessmentParagraph;
          let questionRow = new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({
                  children: [
                    new TextRun({
                      text: statementTag,
                      bold: true,
                      color: "#1F3863",
                      underline: {
                        type: UnderlineType.SINGLE,
                        color: "#1F3863",
                      },
                    })
                  ]
                })], width: { size: "25%", type: WidthType.PERCENTAGE }
              }),
              new TableCell({ children: [new Paragraph(defaultData != null ? defaultData : '')], width: { size: "50%", type: WidthType.PERCENTAGE } }),
              new TableCell({ children: [new Paragraph(questionComment != '' ? question.comment : '')], width: { size: "25%", type: WidthType.PERCENTAGE } }),
            ],
          });

          if ((defaultData != null && defaultData !== '') || (question.comment != null && question.comment !== '')) {
            questionArray.push(questionHeader);
            questionArray.push(questionRow);
          }
        }
        // const userAnswerSelected = question.userAnswers.find((answer: any) => answer.id === question.userAnswerSelectedId);
        // var comment = question.comment;
        // if (comment != null) {
        //   while (comment.includes("<br>")) {
        //     comment = comment.replace("<br>", "\n");
        //   }
        // }
      }
    });

    if (questionArray.length === 0) {
      questionArray.push(
        new TableRow({
          children: [
            new TableCell({
              width: { size: "25%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({
                  text: this.layoutService.translateText('CHECK.REPORT.THEME'),
                  bold: true
                })
                ]
              })], ...headerStyle
            }),
            new TableCell({
              width: { size: "50%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({
                  text: this.layoutService.translateText('CHECK.REPORT.VALORATION'),
                  bold: true
                })
                ]
              })], ...headerStyle
            }),
            new TableCell({
              width: { size: "25%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({
                  text: this.layoutService.translateText('CHECK.REPORT.COMMENT'),
                  bold: true
                })
                ]
              })], ...headerStyle
            }),
          ],
        })
      );
    }

    const questionsTable = new Table({
      rows: questionArray,
      width: { size: "100%", type: WidthType.PERCENTAGE }
    });

    var stationAuditArray: TableRow[] = [];

    const loadStationAudits = new Promise<void>((resolve, reject) => {
      const promises: Promise<any>[] = [];
      if (this.check.stationAudits.length === 0) {
        resolve();
      } else {
        this.checkStorageService.getAllImages(this.check.id).subscribe((resp: any) => {
          this.check.stationAudits = resp;
          resp.sort((a: any, b: any) => a.order - b.order);

          this.check.stationAudits.forEach((stationAudit: any) => {
            promises.push(
              new Promise<void>((innerResolve, innerReject) => {
                var finalheight = 220;
                var finalwidth = 0;
                stationAudit.imageData = stationAudit.imageCircleData;
                if (stationAudit.imageData === null) {
                  if (stationAudit.withPicture) {
                    stationAudit.imageData = this.checkStorageService.getMissingImageBase64();
                  } else {
                    stationAudit.imageData = this.checkStorageService.getEmptyImageBase64();
                  }
                }

                this.loadImageFromBase64(stationAudit.imageData)
                  .then((image: HTMLImageElement) => {
                    let width = image.width;
                    let height = image.height;
                    if (width > height) {
                      finalwidth = 294;
                      finalheight = 220;
                    } else {
                      finalwidth = 220;
                      finalheight = 294;
                    }

                    stationAuditArray.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: "30%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({
                                text: this.layoutService.translateText('CHECK.REPORT.AUDIT_THEME'),
                                bold: true
                              })
                              ]
                            })], ...headerStyle
                          }),
                          new TableCell({
                            width: { size: "40%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({
                                text: this.layoutService.translateText('CHECK.REPORT.RECOMMENDATION'),
                                bold: true
                              })
                              ]
                            })], ...headerStyle
                          }),
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({
                                text: this.layoutService.translateText('CHECK.REPORT.RESPONSIBLE'),
                                bold: true
                              })
                              ]
                            })], ...headerStyle
                          }),
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({
                                text: this.layoutService.translateText('CHECK.REPORT.DEADLINE'),
                                bold: true
                              })
                              ]
                            })], ...headerStyle
                          }),
                        ],
                      })
                    );

                    let stationAuditParagraphArray: Paragraph[] = [];

                    stationAuditParagraphArray.push(new Paragraph(stationAudit.comment));

                    stationAudit.auditQuickComments.forEach((aQuickComment: { quickComment: { title: string; description: string; }; }) => {
                      stationAuditParagraphArray.push(new Paragraph(aQuickComment.quickComment.title ?? ''));
                      stationAuditParagraphArray.push(new Paragraph(aQuickComment.quickComment.description ?? ''));
                    });

                    stationAuditArray.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            rowSpan: 3,
                            width: { size: "30%", type: WidthType.PERCENTAGE },
                            children: [new Paragraph({
                              children: [new TextRun({
                                text: stationAudit.roomNumber,
                                bold: true,
                                color: "#1F3863",
                                underline: {
                                  type: UnderlineType.SINGLE,
                                  color: "#1F3863",
                                },
                              })]
                            }),
                            new Paragraph(""),
                            new Paragraph({
                              children: [new ImageRun({
                                altText: {
                                  title: "stationAudit.roomNumber",
                                  name: "",
                                  description: "",
                                },
                                data: Buffer.from(stationAudit.imageData, 'base64'),
                                transformation: {
                                  width: finalwidth,
                                  height: finalheight,
                                },
                              })]
                            }),

                            ]
                          }),

                          new TableCell({ width: { size: "40%", type: WidthType.PERCENTAGE }, children: stationAuditParagraphArray, rowSpan: 3 }),
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph(
                              {
                                children: [new TextRun({
                                  text: this.layoutService.translateText('CHECK.REPORT.ENTER_RESPONSIBLE_TEXT'),
                                  color: "#0643FD",
                                  vanish: false
                                }),]
                              }
                            ),
                            new Paragraph(""),
                            new Paragraph(""),
                            new Paragraph(""),
                            new Paragraph(""),
                            ], ...blueSpace
                          }),
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph(
                              {
                                children: [new TextRun({
                                  text: this.layoutService.translateText('CHECK.REPORT.ENTER_LATEST_TEXT'),
                                  color: "#0643FD",
                                  vanish: false
                                }),]
                              }
                            ),
                            new Paragraph(""),
                            new Paragraph(""),
                            new Paragraph(""),], ...blueSpace
                          }),
                        ],
                      })
                    );

                    stationAuditArray.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({
                                text: this.layoutService.translateText('CHECK.REPORT.STATUS'),
                                bold: true
                              })
                              ]
                            })], ...headerStyle
                          }),
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [new TextRun({
                                text: this.layoutService.translateText('CHECK.REPORT.PRIORITY'),
                                bold: true
                              })
                              ]
                            })], ...headerStyle
                          }),
                        ],
                      })
                    );

                    stationAuditArray.push(
                      new TableRow({
                        children: [
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph(
                              {
                                children: [new TextRun({
                                  text: this.layoutService.translateText('CHECK.REPORT.ENTER_IMPLEMENTATION_TEXT'),
                                  color: "#0643FD",
                                  vanish: false
                                }),]
                              }
                            )], ...blueSpace
                          }),
                          new TableCell({
                            width: { size: "15%", type: WidthType.PERCENTAGE }, children: [new Paragraph(
                              {
                                children: [new TextRun({
                                  text: this.layoutService.translateText('CHECK.REPORT.ENTER_IMPORTANCE_TEXT'),
                                  color: "#0643FD",
                                  vanish: false
                                }),]
                              }
                            )], ...blueSpace
                          }),
                        ]
                      })
                    );
                    innerResolve();
                  })
                  .catch((error) => {
                    console.error('Error al cargar la imagen: ', error);
                    innerReject(error);
                  });
              })
            );
          });
          Promise.all(promises) // Wait for all promises to resolve
            .then(() => {
              resolve(); // Once all promises have resolved, resolve the main promise
            })
            .catch((error) => {
              reject(error); // Handle any errors that may occur
            });
        });
      }
    });



    loadStationAudits.then(() => {
      console.log("Le da igual la promesa");
      const stationAuditTable = stationAuditArray.length > 0 ? new Table({
        rows: stationAuditArray,
        width: { size: "100%", type: WidthType.PERCENTAGE }
      }) : new Paragraph("");

      var documentChildren = [];
      var pageBreak = new Paragraph({
        children: [new PageBreak()],
      });

      // HEADER SECTION
      documentChildren.push(header);
      documentChildren.push(new Paragraph(""));
      documentChildren.push(userData);
      documentChildren.push(new Paragraph(""));
      documentChildren.push(new Paragraph({
        children: [
          new TextRun({
            text: this.layoutService.translateText('CHECK.REPORT.SUMMARY'),
            bold: true,
            color: "#1F3863",
            size: 24

          })
        ]
      }));
      documentChildren.push(reportComent1);
      documentChildren.push(pageBreak);

      // QUESTION SECTION
      if (questionArray.length > 1) {
        documentChildren.push(new Paragraph({
          children: [
            new TextRun({
              text: this.layoutService.translateText('CHECK.REPORT.AUDIT_ASPECTS'),
              bold: true,
              color: "#1F3863",
              size: 24

            })
          ]
        }));
        documentChildren.push(new Paragraph(""));
        documentChildren.push(questionsTable);
        documentChildren.push(new Paragraph(""));
        documentChildren.push(pageBreak);
      }

      // STATION AUDIT SECTION
      if (stationAuditArray.length > 0) {
        documentChildren.push(new Paragraph({
          children: [
            new TextRun({
              text: this.layoutService.translateText('CHECK.AUDIT_TAB'),
              bold: true,
              color: "#1F3863",
              size: 24

            })
          ]
        }));
        documentChildren.push(new Paragraph(""));
        documentChildren.push(stationAuditTable);
        documentChildren.push(new Paragraph({
          children: [
            new TextRun({
              text: this.layoutService.translateText('CHECK.REPORT.RESPONSABILITY_DEPARTMENT'),
              color: "#0643FD",
              vanish: true
            })
          ]
        }));
        documentChildren.push(new Paragraph(""));
        documentChildren.push(pageBreak);
      }

      // COMMENT SECTION
      if (this.check.userQuestionnaire.showNotes) {
        documentChildren.push(new Paragraph({
          children: [
            new TextRun({
              text: this.layoutService.translateText('CHECK.NOTES_TAB'),
              bold: true,
              color: "#1F3863",
              size: 24
            })
          ]
        }));
        documentChildren.push(reportComments);
        documentChildren.push(new Paragraph(""));
      }
      documentChildren.push(new Paragraph({
        children: [
          new TextRun({
            text: this.layoutService.translateText('CHECK.REPORT.SOURCES'),
            bold: true,
            color: "#1F3863",
            size: 24
          })
        ]
      }));
      documentChildren.push(reportComent2);
      documentChildren.push(new Paragraph(""));
      documentChildren.push(new Paragraph({
        children: [
          new TextRun({
            text: `${this.layoutService.translateText('CHECK.REPORT.ATTACHMENTS')}:`,
            bold: true,
            color: "#1F3863",
            size: 24

          })
        ]
      }));
      documentChildren.push(reportComent3);

      const doc = new Document({
        sections: [
          {
            children: documentChildren,
            properties: {
              page: {
                size: {
                  orientation: PageOrientation.LANDSCAPE
                },
                pageNumbers: {
                  start: 1,
                  formatType: NumberFormat.DECIMAL
                }
              },
            },
            footers: {
              default: new Footer({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        children: [`${this.layoutService.translateText('CHECK.REPORT.PAGE')} `, PageNumber.CURRENT],
                        size: 16
                      }),
                      new TextRun({
                        children: [` ${this.layoutService.translateText('CHECK.REPORT.OF')} `, PageNumber.TOTAL_PAGES],
                        size: 16,
                      }),
                    ],
                    alignment: AlignmentType.CENTER,
                  })
                ]
              })
            }
          }
        ],
        styles: {
          paragraphStyles: [
            {
              id: "Heading1",
              name: 'Normal',
              run: {
                font: 'Calibri',
                size: 22
              }
            }
          ]
        }
      });

      Packer.toBlob(doc).then((blob) => {
        this.layoutService.showLoader = false;
        saveAs(blob, "HygieneCheck-" + this.timeCreated + ".docx");
        this.downloadModalService.closeAndDeleteModal();
      });
    });


  }

  closeModal() {
    this.downloadModalService.closeAndDeleteModal();
  }

  extractTextFromTags(htmlString: string) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;

    const bTagContent = tempElement.querySelector('b');
    const strongTagContent = tempElement.querySelector('strong');

    const extractedText = (bTagContent || strongTagContent)?.textContent || '';
    return extractedText;
  }

  formatDate(inputDate: string): string {
    const date = new Date(inputDate);
    const formattedDate = date.toLocaleDateString(localStorage.getItem('selectedlanguage'), { day: '2-digit', month: '2-digit', year: 'numeric' });
    return formattedDate;
  }

  async getImageBlobFromUrl(url: string) {
    return fetch(url).then((resp) => resp.arrayBuffer());
  }

  loadImageFromBase64(base64String: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = 'data:image/jpeg;base64,' + base64String; // Ajusta el tipo de imagen según corresponda
      img.onload = () => resolve(img);
      img.onerror = (error) => reject(error);
    });
  }

  getUserName() {
    const userData = localStorage.getItem('userData');
    const userDataJSON = userData ? JSON.parse(userData) : {};
    return userDataJSON['name'];
  }

  changeTextByTitle(title: string) {
    switch (title) {
      case 'infektiöser Gastroenteritis':
        return "Infektiöse Gastroenteritis";
      case 'Hygienebeauftragten':
        return "Hygienebeauftragter";
      default:
        return title;
    }
  }

  isYesNoQuestion(question: string) {
    return question === 'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F' // no
        || question === 'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF' //yes
        || question === 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36F' //N/A;
        || question === 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E' //partially
  }

  isAnswerYes(answer: string) {
    return answer === 'Ja' || answer === 'CHECK.REPORT.YES' || answer === 'ANSWEROPTION_CAPTION_AFFDBFEB-FD5F-41F5-B799-9C15313861FF';
  }

  isAnswerNo(answer: string) {
    return answer === 'Nein' || answer === 'CHECK.REPORT.NO' || answer === 'ANSWEROPTION_CAPTION_8AF1A5E2-86FC-4701-BCE6-57097C5F1B8F';
  }

  isAnswerNA(answer: string) {
    return answer === 'N/A' || answer === 'CHECK.REPORT.NA' || answer === 'ANSWEROPTION_CAPTION_C63DC902-A13A-4735-90D1-C6FFF4689B36F';
  }

  isAnswerPartially(answer: string) {
    return answer === 'Teilweise' || answer === 'CHECK.REPORT.PARTIALLY' || answer === 'ANSWEROPTION_CAPTION_EAFB69FC-BF39-45E6-B94A-8715E003A37E';
  }

  transformStatementToQuestion(statement: string): string{
    let statementCopy = statement;
    statementCopy = this.removeAllTags(statementCopy);
    statementCopy = statementCopy.trim();
    statementCopy = statementCopy.replace(/\?/g, '');
    statementCopy = this.changeTextByTitle(statementCopy);

    return statementCopy;
  }

  removeAllTags(htmlString: string) {
    const textWithoutTags = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
    return textWithoutTags;
  }
}
